import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ListProvinceResponse, CityData } from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class AddressService {

  constructor(
    private http: HttpClient
  ) { }

  getProvince(): Observable<ListProvinceResponse> {
    return this.http.get<ListProvinceResponse>(environment.apiUrl + 'clientapi/address/province');
  }

  getCity(filter: string): Observable<CityData[]> {
    let params = new HttpParams;

    if (filter) {
      params = params.append('city_name', filter.toString());
    }

    return this.http.get<CityData[]>(environment.apiUrl + 'clientapi/address/city', {params});
  }

}
